import SupportWidget from './SupportWidget';

export default SupportWidget;



// WEBPACK FOOTER //
// ./src/client/Components/SupportWidget/index.js